var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 821,
    viewBox: "0 0 495 821",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.644 686.101C279.002 690.835 277.052 688.511 276.096 687.372C275.14 686.233 274.179 683.078 278.832 679.174C282.727 675.906 384.383 596.863 417.389 571.205C417.721 570.947 418.114 571.428 417.795 571.702C386.105 598.949 288.515 682.852 284.644 686.101Z",
    fill: "url(#paint0_linear_3813_35331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M453.656 511.093C438.202 524.06 437.164 522.823 436.749 522.328C436.334 521.833 435.296 520.597 450.75 507.629C462.536 497.74 663.544 331.67 758.305 253.389C758.635 253.116 759.048 253.601 758.721 253.877C664.024 333.733 462.32 503.823 453.656 511.093Z",
    fill: "url(#paint1_linear_3813_35331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M675.203 221.372C681.247 216.3 688.697 214.998 690.702 217.089C692.706 219.181 688.303 226.364 683.112 230.798C678.636 234.621 531.942 348.627 491.666 379.922C491.335 380.179 490.944 379.702 491.262 379.428C529.823 346.269 669.992 225.744 675.203 221.372Z",
    fill: "url(#paint2_linear_3813_35331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M574.121 372.805C593.298 357.01 596.594 358.735 597.24 359.376C597.886 360.017 599.331 363.18 579.383 380.136C562.617 394.386 419.771 507.611 374.611 543.381C374.28 543.644 373.89 543.158 374.211 542.883C418.242 505.309 557.992 386.088 574.121 372.805Z",
    fill: "url(#paint3_linear_3813_35331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.443 629.994C415.901 638 406.016 643.38 404.592 641.065C403.168 638.75 411.39 630.012 419.617 623.051C426.51 617.22 641.683 442.98 711.316 386.601C711.647 386.333 712.054 386.816 711.729 387.092C643.604 444.913 433.433 623.289 425.443 629.994Z",
    fill: "url(#paint4_linear_3813_35331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.149 512.489C116.833 519.467 115.58 517.973 114.965 517.24C114.351 516.508 114.555 513.79 121.413 508.036C126.853 503.471 259.421 395.846 313.961 351.574C314.292 351.306 314.695 351.793 314.371 352.068C260.794 397.505 130.557 507.951 125.149 512.489Z",
    fill: "url(#paint5_linear_3813_35331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M429.836 428.065C438.151 421.087 439.405 422.581 440.019 423.314C440.634 424.046 440.429 426.764 433.572 432.517C428.131 437.083 295.563 544.708 241.024 588.979C240.693 589.248 240.289 588.761 240.614 588.486C294.19 543.049 424.427 432.603 429.836 428.065Z",
    fill: "url(#paint6_linear_3813_35331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M644.083 482.797C652.417 475.804 650.467 473.48 649.511 472.341C648.555 471.202 645.144 470.104 638.271 475.871C632.518 480.698 489.995 606.545 443.72 647.412C443.403 647.692 443.81 648.169 444.137 647.9C491.748 608.606 638.364 487.596 644.083 482.797Z",
    fill: "url(#paint7_linear_3813_35331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.343 718.402C89.6888 733.83 90.7308 738.2 91.979 739.687C93.2273 741.175 99.9256 740.04 114.933 727.447C127.847 716.611 364.115 509.726 429.769 452.227C430.089 451.948 429.683 451.472 429.356 451.742C361.593 507.76 116.483 710.414 107.343 718.402Z",
    fill: "url(#paint8_linear_3813_35331)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M542.224 285.447C546.578 281.793 545.087 279.084 544.132 277.945C543.176 276.805 540.766 274.867 536.412 278.521C532.767 281.579 460.212 348.715 436.666 370.51C436.36 370.794 436.765 371.256 437.088 370.993C462.077 350.68 539.234 287.956 542.224 285.447Z",
    fill: "url(#paint9_linear_3813_35331)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M477.458 684.489C470.817 690.061 472.975 692.633 473.931 693.772C474.886 694.911 477.794 696.01 483.27 691.415C487.448 687.909 581.627 603.688 626.05 563.949C626.678 563.387 625.865 562.439 625.214 562.975C579.177 600.811 481.611 681.004 477.458 684.489Z",
    fill: "url(#paint10_linear_3813_35331)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M343.653 470.271C356.934 459.128 355.545 457.473 354.93 456.739C354.315 456.006 350.864 456.624 339.912 465.813C332.288 472.211 171.889 609.587 75.14 692.461C74.4904 693.017 75.3121 693.99 75.9691 693.442C173.834 611.869 336.074 476.631 343.653 470.271Z",
    fill: "url(#paint11_linear_3813_35331)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.952 351.018C442.593 345.446 451.368 333.99 445.701 328.475C440.034 322.96 428.627 331.167 423.151 335.762C418.522 339.646 307.225 447.079 272.862 480.263C272.271 480.834 273.072 481.741 273.714 481.227C310.943 451.391 431.352 354.878 435.952 351.018Z",
    fill: "url(#paint12_linear_3813_35331)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M613.984 429.422C629.129 416.186 637.637 405.947 632.264 401.352C626.891 396.756 610.628 409.192 602.636 415.898C595.953 421.506 433.016 570.412 379.795 619.063C379.177 619.628 379.983 620.562 380.632 620.033C436.502 574.496 607.454 435.128 613.984 429.422Z",
    fill: "url(#paint13_linear_3813_35331)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.143 565.82C92.0313 575.143 90.9934 573.906 90.5783 573.412C90.1631 572.917 89.1253 571.68 100.237 562.357C108.71 555.246 253.596 436.269 321.899 380.188C322.23 379.917 322.64 380.402 322.313 380.678C254.281 438.16 109.372 560.593 103.143 565.82Z",
    fill: "url(#paint14_linear_3813_35331)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.784 344.365C291.606 360.159 288.31 358.435 287.664 357.794C287.018 357.153 285.573 353.99 305.522 337.034C322.287 322.783 465.133 209.559 510.293 173.789C510.624 173.526 511.015 174.012 510.693 174.287C466.662 211.861 326.912 331.082 310.784 344.365Z",
    fill: "url(#paint15_linear_3813_35331)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M374.032 548.956C383.574 540.95 394.505 536.817 397.189 540.633C399.872 544.449 392.31 553.974 384.104 560.96C376.894 567.097 138.137 755.432 80.2369 801.097C79.9056 801.359 79.5149 800.871 79.8355 800.597C135.719 752.769 365.652 555.988 374.032 548.956Z",
    fill: "url(#paint16_linear_3813_35331)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M389.476 433.726C398.234 426.377 396.076 423.806 395.12 422.667C394.164 421.528 390.886 420.74 383.665 426.799C378.155 431.422 253.16 541.501 194.194 593.443C193.558 594.004 194.374 594.96 195.028 594.42C255.609 544.38 384 438.321 389.476 433.726Z",
    fill: "url(#paint17_linear_3813_35331)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M561.207 566.557C580.384 550.762 583.68 552.487 584.326 553.128C584.972 553.769 586.417 556.932 566.469 573.888C549.703 588.138 406.857 701.363 361.697 737.133C361.366 737.396 360.976 736.91 361.297 736.635C405.328 699.061 545.078 579.84 561.207 566.557Z",
    fill: "url(#paint18_linear_3813_35331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3813_35331",
    x1: 275.888,
    y1: 687.124,
    x2: 420.847,
    y2: 565.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFC2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3813_35331",
    x1: 438.266,
    y1: 520.845,
    x2: 785.255,
    y2: 232.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AADED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3813_35331",
    x1: 686.61,
    y1: 219.832,
    x2: 483.552,
    y2: 390.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334BCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3813_35331",
    x1: 596.485,
    y1: 359.997,
    x2: 362.675,
    y2: 556.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1777DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3813_35331",
    x1: 410.765,
    y1: 636.394,
    x2: 731.333,
    y2: 367.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3813_35331",
    x1: 115.172,
    y1: 517.066,
    x2: 336.114,
    y2: 331.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3689DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FADF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3813_35331",
    x1: 439.812,
    y1: 423.487,
    x2: 218.87,
    y2: 608.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3689DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FADF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3813_35331",
    x1: 649.511,
    y1: 472.34,
    x2: 440.731,
    y2: 647.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3813_35331",
    x1: 97.9588,
    y1: 733.988,
    x2: 428.173,
    y2: 456.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3813_35331",
    x1: 543.672,
    y1: 278.33,
    x2: 434.588,
    y2: 369.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3813_35331",
    x1: 473.723,
    y1: 693.525,
    x2: 631.754,
    y2: 560.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01356B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3813_35331",
    x1: 355.063,
    y1: 456.899,
    x2: 39.0481,
    y2: 722.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01356B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3813_35331",
    x1: 436.192,
    y1: 337.817,
    x2: 278.162,
    y2: 470.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05498E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3813_35331",
    x1: 618.002,
    y1: 414.528,
    x2: 387.373,
    y2: 608.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C4987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3813_35331",
    x1: 91.6398,
    y1: 572.31,
    x2: 340.847,
    y2: 364.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AADED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3813_35331",
    x1: 288.419,
    y1: 357.173,
    x2: 522.229,
    y2: 160.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1777DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3813_35331",
    x1: 390.832,
    y1: 545.086,
    x2: 70.2645,
    y2: 814.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3813_35331",
    x1: 395.328,
    y1: 422.914,
    x2: 186.944,
    y2: 597.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01356B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3813_35331",
    x1: 583.571,
    y1: 553.749,
    x2: 349.761,
    y2: 749.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1777DA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.1ad15c5eeb44c524885526f9cac39118.svg";
export { ForwardRef as ReactComponent };